<template>
    <div class="container">
        <ContentOrLoading>
            <b-row v-if="!loading">            
                <b-col md="8" sm="12">
                    <h3 class="subtitle h4 light mb-3 mb-lg-4">A) {{ $t('nuevo_abono.pinchando_mapa') }}:</h3>
                    <RenderSvgComponent
                        :svg="svg"
                        :zonas="zonas"
                        @clickZona="seleccionarZona"
                    />                            
                </b-col>
                <b-col md="4" sm="12">
                    <h3 class="subtitle h4 light mb-3 mb-lg-4 ">B) {{ $t('nuevo_abono.tabla') }}:</h3>
                    <TablaSectoresComponent 
                        :zonas="zonas" 
                        @clickZona="seleccionarZona"
                    />
                </b-col>               
            </b-row>
        </ContentOrLoading>        
    </div>
</template>

<script>
    import RenderSvgComponent from '@/components/common/svg/normal/RenderSvgComponent';
    import TablaSectoresComponent from '@/components/frontend/abonos/nuevo/TablaSectoresComponent';

    export default {
        data() {
            return {
                svg: null,
                zonas: [],
                loading: true,
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        },
        created() {
            this.getZonas();
        },
        methods: {
            getZonas() {
                this.$store.dispatch(this.config.getVuexAlias('sga.abonados.get.zonas'), {}).then(res => {
                    this.zonas = res.data.zonas;
                    this.svg = res.data.svg;
                }).finally(() => this.loading = false);
            },
            seleccionarZona(zona) {
                this.$emit('zonaSeleccionada', zona);
            },
            volver() {
                alert('Volver');
            },
        },
        components: {
            RenderSvgComponent, TablaSectoresComponent
        }
    }
</script>